import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { jumpToUser, } from 'src/helper/webviewFun'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import http from 'src/helper/http'
import Message from 'src/component/Message'
import lang from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import ReminderBtn from 'src/component/myRuleButton'
@inject('store')
@observer

export default class Couples extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    cpList: [],
    hadCp: false,
    selectCardIndex: 0,
    toUp: {},
    myAvatarurl: '',
    myNickname: '',
    userSendInputValue: '',
    myCpListCard: [],
    rankingList: [],
    forbidPower: 0,
    delCpId: -99,
    selectSoreItem: 0,
    treeList: [],
    blesscpItem: {},
    voteReward: [],
    topReward: [],
    lang: lang.en,
    language: 'en',
    scroll: '0,20',
    showInse: false,
    showSend: false,
    minute:0,
    day:0,
    hour:0,
    second:0,
  }

  async componentDidMount() {
    const uid = await setUidToken(this.props.location.query)
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language || 'en', lang),
      language: language,
      uid
    })
    this.getCpRankListTree()
    this.getCprewardlist()
    this.getCpList()
    this.getUserInfo()
    this.getMyCpListCard()
    this.getRankingList()
    this.getCountDownTime()
  }
  //获取cp 列表
  getCpList = async () => {
    let res = await http.post('/web/valentine/mycpuserlist')
    if (res.code == 0 && res.res.length) {
      this.setState({
        cpList: res.res,
        hadCp: true,
        toUp: res.res[0],
      })
    }
  }
  //getCountDownTime/
  getCountDownTime = async () => {
    let nowTime = Math.floor(new Date().getTime() / 1000)
    let res = await http.post('web/valentine/timeinfo')
    if (nowTime > res.res.beginTimestamp) {
      this.countDown(res.res.leftTimestamp)
    }
  }
  // getUserInfo()
  getUserInfo = async () => {
    let res = await http.post('/web/MyAccountInfo')
    if (res.code == 0) {
      this.setState({
        myAvatarurl: res.res.avatarurl,
        myNickname: res.res.nickname,
        forbidPower: res.res.forbidPower,
      })
    }
  }
  //
  unLockcp = async (close) => {
    let { userSendInputValue, toUp, lang } = this.state
    if (!userSendInputValue) return this.refs.msg.show(lang.pleaseentertextfirst)
    let res = await http.post('/web/valentine/unlockcp', { content: userSendInputValue, cpId: toUp.cpId, toUid: toUp.uid })
    if (res.code == 0) {
      this.setState({
        userSendInputValue: '',
      })
      close()
      document.querySelector('#clearName').value = ''
      this.getMyCpListCard()
      this.getRankingList('0,20')
      this.refs.msg.show(lang.successful)
    } else {
      this.refs.msg.show(res.msg)
    }
  }

  getMyCpListCard = async () => {
    let res = await http.post('/web/valentine/mycpcardlist')
    if (res.code == 0 && res.res.length) {
      this.setState({
        myCpListCard: res.res,
      })
    }
  }
  getRankingList = async (a) => {
    let { scroll, } = this.state
    let res = await http.post('/web/valentine/allcplist', { scroll: a ? a : scroll })
    if (res.code == 0) {
      this.setState({
        rankingList: res.res.list.length && [...res.res.list],
        scroll: res.res.scroll,
        hasMore: res.res.hasMore,
      })
    }
  }
  // get
  getUserSendInputValue = (e) => {
    this.setState({
      userSendInputValue: e.target.value
    })
  }
  //
  getCpRankListTree = async () => {
    let res = await http.post('/web/valentine/cpRankList')
    if (res.code == 0 && res.res.length) {
      await this.setState({
        treeList: res.res,
      })
    }
    let ii = document.getElementsByClassName("sway-root")
    let el = document.querySelector('.sway-root-two')
    let elt = document.querySelector('.sway-root-three')
    let elf = document.querySelector('.sway-root-four')
    let els = document.querySelector('.sway-root-five')
    let start = Date.now();

    ii && this.swing(ii[0], 0, start);
    el && this.swing(el, 0, start + Math.random() * 1000);
    elt && this.swing(elt, 0, start + Math.random() * 1000 - 500);
    elf && this.swing(elf, 0, start + Math.random() * 1000 + 300);
    els && this.swing(els, 0, start + Math.random() * 1000 + 900);
  }
  //
  getCprewardlist = async () => {
    let res = await http.post('/web/valentine/cprewardlist')
    if (res.code == 0) {
      this.setState({
        voteReward: res.res.voteReward,
        topReward: [res.res.rankReward1, res.res.rankReward2, res.res.rankReward3, res.res.rankReward4, res.res.rankReward5]
      })
    }
  }
  //
  deleteCpId = async (close) => {
    let res = await http.post('/web/valentine/removeCpItem', { cpId: this.state.delCpId })
    if (res.code == 0) {
      close()
      this.getMyCpListCard()
      this.getRankingList('0,20')
      this.getCpRankListTree()
      this.refs.msg.show(this.state.lang.successful)
    } else {
      this.refs.msg.show(res.msg)
    }
  }
  //
  handleSelectItem = (item, index) => {
    this.setState({
      toUp: item,
      selectCardIndex: index,
    })
  }
  //
  handelSelectSoreItem = (e) => {
    this.setState({
      selectSoreItem: e
    })
  }
  //showNocpModle
  showNocpModle = (open, close) => {
    let { lang } = this.state
    return (
      <div
        className="nocp-modle"
      >
        <div className='nocp-modle-title'>{lang.donnothadCp}</div>
        <div className='text-conter-innocp'>{lang.nocpTip}</div>
        <div className='cle' onClick={() => close()}>{lang.okText}</div>
        <div style={{ height: '0.24rem' }}></div>
      </div>
    )
  }
  showDelModle = (open, close) => {
    return (
      <div
        className="delete-modle"
      >
        <div className='nocp-modle-title'>Delete?</div>

        <div className='delete-btn' >
          <div className='in-ok' onClick={() => this.deleteCpId(close)}>OK</div>
          <div className='no' onClick={() => close()}>No</div>
        </div>
      </div>
    )
  }
  //showSendModle
  showSendModle = (open, close) => {
    let { cpList, selectCardIndex, toUp, myAvatarurl, myNickname, lang, language } = this.state
    return (
      <div
        className="send-modle"
      >
        <div className='select-user'>
          {cpList.length > 0 && cpList.map((item, index) => (<div className={`in-select ${index == selectCardIndex ? 'show-root-item' : ''}`} key={index} onClick={() => this.handleSelectItem(item, index)}>
            <div className='img-root'>
              <img src={item.avatarurl} className='user-url'></img>
              {index == selectCardIndex && <img className='flx-in' src='/img/activity/valentineDay/controls_checkbox_selected.png'></img>}
            </div>
            <div className='name-in-user'>{item.nickname}</div>
            <div className='user-id'>ID: {item.duid}</div>
          </div>))}
        </div>
        <div className='send-modle-my-card-item' >
          <img className='my-card-item-img' src='/img/activity/valentineDay/img_lovecards_pink_new.png' style={{ transform: `${language == 'ar' ? 'scaleX(-1)' : ''}` }}></img>
          <div className='text-root'>
            <div className='top-root-in-my-card'>
              <div className='left'>
                {lang.to}<span >{toUp.nickname}</span>
                <img className='rg-img' src={toUp.avatarurl}></img>
              </div>
            </div>
            <textarea id='clearName' className='body-root-in-my-card' rows="3" cols="100" maxLength={100} onChange={(e) => this.getUserSendInputValue(e)} placeholder={lang.saysomethingtoyourlover}></textarea>
            <div className={`floor-root-in-my-card ${this.state.language !== 'ar' ? 'lt-text' : 'rt-text'}`} >
              {lang.from}<span >{myNickname}</span>
              <img src={myAvatarurl}></img>
            </div>
          </div>
          <div className='love-num'>
            <img src='/img/activity/valentineDay/icon_heartx.png'></img>
          </div>
        </div>
        <div className='send-btn' onClick={() => this.unLockcp(close)}>
          <span>{lang.payText}</span> <img src='/img/activity/valentineDay/icon_ruby.png' className='send-btn-img'></img><span>{lang.sendNum}</span>
        </div>
        <div className='cancel-btn' onClick={() => close()}>{lang.cancel}</div>
      </div>
    )
  }
  // 
  showPrizeModle = (open, close) => {
    let { topReward, voteReward, language, lang } = this.state
    return (
      <div
        className="prize-modle"
      >
        <img className='bg-in-prize-modle' src='/img/activity/valentineDay/prize_border_bg.png'></img>
        <img src={language == 'ar' ? '/img/activity/valentineDay/prize-modle_title_bg_ar.png' : language == 'tr' ? '/img/activity/valentineDay/prize-modle_title_bg_tr.png' : '/img/activity/valentineDay/prize-modle_title_bg.png'} className='top-title'></img>
        <div className='prize-modle-body-root'>
          <div className='prize-modle-body'>

            {topReward.length > 0 && topReward.map((item, index) => (<div className='prize-body-item' key={index}>
              <div className='title-index'>{`Top${index + 1}`}</div>
              <div className='body-show-item'>
                {item.length > 0 && item.map((i, d) => (<div className='item-in-prize' key={d + 62}>
                  <div className='img-root'>
                    <img className='img-root-img' style={{ padding: `${i.rewardType == 'title' ? '0.42rem 0' : '0 0'}`, boxSizing: 'border-box' }} src={language == 'tr' ? i.picTr : language == 'ar' ? i.picAr : i.pic}></img>
                    <div className='gift-time-root' >{language == 'ar' ? i.rewardNum + 'يوم' : language == 'tr' ? i.rewardNum + 'Gün' : i.rewardNum + 'day'}</div>
                  </div>
                  <div className='name-text'>{language == 'tr' ? i.rewardNameTr : language == 'ar' ? i.rewardNameAr : i.rewardName}</div>
                </div>))}
              </div>
            </div>))}
            <div className='prize-body-item' >
              <div className='title-index'>{lang.voting}</div>
              <div className='body-show-item'>
                {voteReward.length > 0 && voteReward.map((item, index) => (<div className='item-in-prize' key={item.rewardId}>
                  <div className='img-root'>
                    <img className='img-root-img' style={{ padding: `${item.rewardType == 'title' ? '0.42rem 0' : '0 0'}`, boxSizing: 'border-box' }} src={language == 'tr' ? item.picTr : language == 'ar' ? item.picAr : item.pic}></img>
                    <div className='gift-time-root' >{language == 'ar' ? item.rewardNum + 'يوم' : language == 'tr' ? item.rewardNum + 'Gün' : item.rewardNum + 'day'}</div>
                  </div>
                  <div className='name-text'>{language == 'tr' ? item.rewardNameTr : language == 'ar' ? item.rewardNameAr : item.rewardName}</div>
                </div>))}

              </div>
            </div>
            <div style={{ height: '0.24rem' }}></div>
          </div>
        </div>
      </div>
    )
  }
  //
  showRulesModle = (open, close) => {
    let { language } = this.state
    return (
      <div
        className="rules-modle"
      >
        <img className='bg-in-prize-modle' src='/img/activity/valentineDay/rules_border_bg.png'></img>
        <img src={language == 'ar' ? '/img/activity/valentineDay/rules-modle_title_bg_ar.png' : language == 'tr' ? '/img/activity/valentineDay/rules-modle_title_bg_tr.png' : '/img/activity/valentineDay/rules-modle_title_bg.png'} className='top-title'></img>
        <div style={{ height: '0.28rem' }}></div>
        <div className='prize-modle-body'>
          <div className="ye" dangerouslySetInnerHTML={{ __html: this.state.lang ? this.state.lang.rewardRule : '' }}></div>
          <div style={{ height: '1rem' }}></div>
        </div>
      </div>
    )
  }
  showVoteMolde = (open, close) => {
    let { selectSoreItem, lang } = this.state
    return (
      <div
        className="vote-modle"

      >
        <div className='vote-modle-body'>
          <div className='show-item'>
            <div className='title'>{lang.blessOne}</div>
            <div className={`select-item-invote ${selectSoreItem == 0 ? 'in-select' : ''}`} onClick={() => this.handelSelectSoreItem(0)}>
              <img className='show-img' src='/img/activity/valentineDay/icon_coin.png'></img>
              <div>{lang.fifty}</div>
            </div>
          </div>
          <div className='show-item-two'>
            <div className='title'>{lang.blessTwo}</div>
            <div className={`select-item-invote ${selectSoreItem == 1 ? 'in-select' : ''}`} onClick={() => this.handelSelectSoreItem(1)}>
              <img className='show-img' src='/img/activity/valentineDay/icon_coin.png'></img>
              <div>{lang.hundredGold}</div>
            </div>
          </div>
          <div className='show-item'>
            <div className='title'>{lang.blessThree}</div>
            <div className={`select-item-invote ${selectSoreItem == 2 ? 'in-select' : ''}`} onClick={() => this.handelSelectSoreItem(2)}>
              <img className='show-img' src='/img/activity/valentineDay/icon_ruby_big.png'></img>
              <div>{lang.hundredRuby}</div>
            </div>
          </div>
        </div>
        <div className='send-btn' onClick={() => this.handleBlesscp(close)} >
          {lang.confirm}
        </div>
        <div className='cancel-btn' onClick={() => close()}>{lang.cancel}</div>
      </div>
    )
  }
  //
  handleBlesscp = async (close) => {
    let { blesscpItem, selectSoreItem } = this.state
    let res = await http.post('/web/valentine/blesscp', { cpId: blesscpItem.cpId, blessIndex: selectSoreItem })
    if (res.code == 0) {
      this.getMyCpListCard()
      this.getCpRankListTree()
      this.getRankingList('0,20')
      this.refs.msg.show(this.state.lang.successful)
      close()
    } else {
      this.refs.msg.show(res.msg)
    }
  }
  //del card item
  delCardItem = (e) => {
    this.setState({
      delCpId: e
    })

  }
  //setHandleBlessItem
  setHandleBlessItem = (e) => {
    this.setState({
      blesscpItem: e,
      showInse: true,
    })
    console.log(e)
  }
  //handleScroll
  handleScroll = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target
    let { hasMore } = this.state
    if ((scrollTop + clientHeight + 30) >= scrollHeight) {
      if (hasMore) return this.addRankingList()
    }
  }

  addRankingList = async () => {
    let { scroll, rankingList } = this.state
    let res = await http.post('/web/valentine/allcplist', { scroll })
    if (res.code == 0) {
      this.setState({
        rankingList: res.res.list.length && [...rankingList, ...res.res.list],
        scroll: res.res.scroll,
        hasMore: res.res.hasMore,
      })
    }
  }
  swing = (element, angle, start) => {
    let amplitude = 8; // 最大旋转角度
    let period = 6000; // 一个往返摆动的毫秒数
    let time = Date.now() - start;
    // 使用正弦函数来模拟摆动效果
    angle = amplitude * Math.sin((time % period) / period * 2 * Math.PI);
    // 应用旋转到元素
    element.style.transform = 'rotate(' + angle + 'deg)';
    element.style.transformOrigin = 'top';
    // 安排下一帧
    requestAnimationFrame(() => { this.swing(element, angle, start); });
  }

  countDown = (times = 2299085) => {
    let { lang } = this.state
    var timer = null
    timer = setInterval(
      () => {
        var day = 0,
          hour = 0,
          minute = 0,
          second = 0
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24))
          hour = Math.floor(times / (60 * 60)) - day * 24
          minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
          second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
        }
        if (day <= 9) day = day
        if (hour <= 9) hour = '0' + hour
        if (minute <= 9) minute = '0' + minute
        if (second <= 9) second = '0' + second
        let daystr = ''
        if (day > 0) {
          // daystr = day
          daystr = day + ' ' + lang.days
        }
        this.setState({
          minute,
          day,
          hour,
          second
        })
        times--

      },
      1000
    )
    if (times <= 0) {
      clearInterval(timer)
    }
  }
  closeViewRoot = () => {
    this.setState({
      showInse: false,
      showSend: false,
    })
  }
  shopEvent = (e) => {
    e.stopPropagation()
    this.closeViewRoot()
  }
  shopVoteEvent = (e) => {
    e.stopPropagation()
  }
  handleSendm = () => {
    this.setState({
      showSend: true
    })
  }
  render() {
    let { lang, language, hadCp, myCpListCard, rankingList, forbidPower, treeList, day, hour, second, showInse, minute, selectSoreItem, showSend, cpList, selectCardIndex, toUp, myAvatarurl, myNickname, voteReward } = this.state
    return (
      <div className={`thumbs-up ${this.state.language == 'ar' ? 'arlang' : ''}`} key={9}>
        <div className='banner-root'>
          <div style={{ height: '2.06rem' }}></div>
          <div className={language == 'ar' ? 'title-root-ins-ar' : language == 'tr' ? 'title-root-ins-tr' : 'title-root-ins'}>
            <div className='bootm'>{lang ? lang.provetomeyourlove : ''}</div>
          </div>
          <ReminderBtn
            lang={lang}
            slotButtonComp={() => {
              return <div className="rules" >
                {lang ? lang.rule : ''}
              </div>
            }}
            slotContentComp={this.showRulesModle}
          />

          <ReminderBtn
            lang={lang}
            slotButtonComp={() => {
              return <div className="prize" >
                {lang.prize}
              </div>
            }}
            slotContentComp={this.showPrizeModle}
          />

          <div className='sway-root'>
            <img className='line' src='/img/activity/valentineDay/line_img.png'></img>
            {treeList.length > 0 && treeList[3] && <img className='user-one' src={treeList[3].sendAvatar} onClick={() => jumpToUser(treeList[3].sendUid)}></img>}
            {!treeList[3] && <img className='user-one' src='/img/activity/valentineDay/icon_add_small_img.png' ></img>}
            <img className='line' src='/img/activity/valentineDay/line_img.png'></img>
            {treeList.length > 0 && treeList[3] && <img className='user-two' src={treeList[3].toAvatar} onClick={() => jumpToUser(treeList[3].toUid)}></img>}
            {!treeList[3] && <img className='user-one' src='/img/activity/valentineDay/icon_add_small_img.png' ></img>}
          </div>
          <div className='sway-root-two'>
            <img className='line' src='/img/activity/valentineDay/line_img.png'></img>
            {treeList.length > 0 && treeList[1] && <img className='user-one' src={treeList[1].sendAvatar} onClick={() => jumpToUser(treeList[1].sendUid)}></img>}
            {!treeList[1] && <img className='user-one' src='/img/activity/valentineDay/icon_add_small_img.png' onClick={() => this.handleSendm()} ></img>}
            <img className='line' src='/img/activity/valentineDay/line_img.png'></img>
            {treeList.length > 0 && treeList[1] && <img className='user-two' src={treeList[1].toAvatar} onClick={() => jumpToUser(treeList[1].toUid)}></img>}
            {!treeList[1] && <img className='user-one' src='/img/activity/valentineDay/icon_add_small_img.png' onClick={() => this.handleSendm()} ></img>}
          </div>
          <div className='sway-root-three'>
            <img className='line' src='/img/activity/valentineDay/line_img.png'></img>
            {!treeList[0] && <img className='user-one' src='/img/activity/valentineDay/icon_add_big_img.png' onClick={() => this.handleSendm()} ></img>}
            {treeList.length > 0 && treeList[0] && <img className='user-one' src={treeList[0].sendAvatar} onClick={() => jumpToUser(treeList[0].sendUid)}></img>}
            <img className='line' src='/img/activity/valentineDay/line_img.png'></img>
            {!treeList[0] && <img className='user-one' src='/img/activity/valentineDay/icon_add_big_img.png' onClick={() => this.handleSendm()} ></img>}
            {treeList.length > 0 && treeList[0] && <img className='user-two' src={treeList[0].toAvatar} onClick={() => jumpToUser(treeList[0].toUid)}></img>}
          </div>
          <div className='sway-root-four'>
            <img className='line' src='/img/activity/valentineDay/line_img.png'></img>
            {treeList.length > 0 && treeList[2] && <img className='user-one' src={treeList[2].sendAvatar} onClick={() => jumpToUser(treeList[2].sendUid)}></img>}
            {!treeList[2] && <img className='user-one' src='/img/activity/valentineDay/icon_add_small_img.png' onClick={() => this.handleSendm()} ></img>}
            <img className='line' src='/img/activity/valentineDay/line_img.png'></img>
            {treeList.length > 0 && treeList[2] && <img className='user-two' src={treeList[2].toAvatar} onClick={() => jumpToUser(treeList[2].toUid)}></img>}
            {!treeList[2] && <img className='user-one' src='/img/activity/valentineDay/icon_add_small_img.png' onClick={() => this.handleSendm()}></img>}
          </div>
          <div className='sway-root-five'>
            <img className='line' src='/img/activity/valentineDay/line_img.png'></img>
            {treeList.length > 0 && treeList[4] && <img className='user-one' src={treeList[4].sendAvatar} onClick={() => jumpToUser(treeList[4].sendUid)}></img>}
            {!treeList[4] && <img className='user-one' src='/img/activity/valentineDay/icon_add_small_img.png' onClick={() => this.handleSendm()} ></img>}
            <img className='line' src='/img/activity/valentineDay/line_img.png'></img>
            {treeList.length > 0 && treeList[4] && <img className='user-two' src={treeList[4].toAvatar} onClick={() => jumpToUser(treeList[4].toUid)}></img>}
            {!treeList[4] && <img className='user-one' src='/img/activity/valentineDay/icon_add_small_img.png' onClick={() => this.handleSendm()}></img>}
          </div>

        </div>
        {hadCp && <ReminderBtn
          lang={lang}
          slotButtonComp={() => {
            return <div className='send-love-card'>{lang.sendaLoveCard}</div>
          }}
          slotContentComp={this.showSendModle}
        />}
        {!hadCp && <ReminderBtn
          lang={lang}
          slotButtonComp={() => {
            return <div className='send-love-card'>{lang.sendaLoveCard}</div>
          }}
          slotContentComp={this.showNocpModle}
        />}
        <div className='time-down'><span className='text'>{lang.timeR}</span> <span className='days-num'>{day}</span> <span className='days-text'>{lang.days}</span><span className='mit'>{hour}:{minute}:{second}</span></div>
        <div className='in-page-vote'>
          <img className='in-page-vote-title-img' src={language == 'ar' ? '/img/activity/valentineDay/voting_rewards_ar.png' : language == 'tr' ? '/img/activity/valentineDay/voting_rewards_tr.png' : '/img/activity/valentineDay/voting_rewards_en.png'}></img>
          <img className='in-page-vote-title-img_bg' src='/img/activity/valentineDay/voting_rewards_bg.png'></img>
          <div className='' style={{ height: "0.28rem", width: "0.1rem" }}></div>
          <div className='in-page-vote-body'>
            <div className='voting-rewards'>
              <div className='voting-rewards-item'>
                {voteReward.length > 0 && voteReward.map((item, index) => (<div className='item-in-prize' key={item.rewardId}>
                  <div className='img-root'>
                    <img className='img-root-img' style={{ padding: `${item.rewardType == 'title' ? '0.42rem 0' : '0 0'}`, boxSizing: 'border-box' }} src={language == 'tr' ? item.picTr : language == 'ar' ? item.picAr : item.pic}></img>
                    <div className='gift-time-root' >{language == 'ar' ? item.rewardNum + 'يوم' : language == 'tr' ? item.rewardNum + 'Gün' : item.rewardNum + 'day'}</div>
                  </div>
                  <div className='name-text'>{language == 'tr' ? item.rewardNameTr : language == 'ar' ? item.rewardNameAr : item.rewardName}</div>
                </div>))}
              </div>
            </div>
          </div>
        </div>
        {myCpListCard.length > 0 && <img className='my-card' src={language == 'ar' ? '/img/activity/valentineDay/my-card_bg_ar.png' : language == 'tr' ? '/img/activity/valentineDay/my-card_bg_tr.png' : '/img/activity/valentineDay/my-card_bg.png'}></img>}
        {myCpListCard.length > 0 && myCpListCard.map((item, index) => (<div className='my-card-item' key={index}>
          <img className='my-card-item-img' src='/img/activity/valentineDay/my_card_item_bg.png' style={{ transform: `${language == 'ar' ? 'scaleX(-1)' : ''}` }}></img>
          <div className='text-root'>
            <div className='top-root-in-my-card'>
              <div className='left'>
                {lang.to}<span >{item.toNickname}</span>
                <img className='rg-img' src={item.toAvatar}></img>
              </div>
              <div className='rg'>
                <img src='/img/activity/valentineDay/icon_room_profilecard_followed.png'></img>
                {/* <ReminderBtn
                  lang={lang}
                  slotButtonComp={() => {
                    return <div className='bless-text' onClick={() => this.setHandleBlessItem(item)}>{lang.bless}</div>
                  }}
                  slotContentComp={this.showVoteMolde}
                /> */}
                <div className='bless-text' onClick={() => this.setHandleBlessItem(item)}>{lang.bless}</div>
              </div>
            </div>
            <div className='body-root-in-my-card'>{item.content}</div>
            <div className={`floor-root-in-my-card ${this.state.language !== 'ar' ? 'lt-text' : 'rt-text'}`} >
              {lang.from}<span >{item.sendNickname}</span>
              <img src={item.sendAvatar}></img>
            </div>
          </div>
          <div className='love-num'>
            <img src='/img/activity/valentineDay/icon_heartx.png'></img>
            <span>{item.score}</span>
          </div>
        </div>))}

        <img className='ranking-card' src={language == 'ar' ? '/img/activity/valentineDay/ranking-card_bg_ar.png' : language == 'tr' ? '/img/activity/valentineDay/ranking-card_bg_tr.png' : '/img/activity/valentineDay/ranking-card_bg.png'}></img>
        <div className='ranking-root' onScroll={(e) => this.handleScroll(e)}>
          {rankingList.length > 0 && rankingList.map((item, index) => (
            <div className='ranking-card-item' key={index}>
              <img className='ranking-card-item-img' src='/img/activity/valentineDay/ranking_card_item_bg.png' style={{ transform: `${language == 'ar' ? 'scaleX(-1)' : ''}` }}></img>
              {forbidPower > 0 && <ReminderBtn
                lang={lang}
                slotButtonComp={() => {
                  return <img className='admin-del-item' src='/img/activity/valentineDay/icon_close.png' onClick={() => this.delCardItem(item.cpId)}></img>
                }}
                slotContentComp={this.showDelModle}
              />}
              <div className='text-root'>
                <div className='top-root-in-my-card' >
                  <div className='left'>
                    {lang.to}<span >{item.toNickname}</span>
                    <img className='rg-img' src={item.toAvatar}></img>
                  </div>
                  <div className='ranking-card-item-rg'>
                    <img src='/img/activity/valentineDay/icon_room_profilecard_followed.png'></img>
                    {/* <ReminderBtn
                      lang={lang}
                      slotButtonComp={() => {
                        return <div className='rg-ranking-btn' onClick={() => this.setHandleBlessItem(item)}>{lang.bless}</div>
                      }}
                      slotContentComp={this.showVoteMolde}
                    /> */}
                    <div className='rg-ranking-btn' onClick={() => this.setHandleBlessItem(item)}>{lang.bless}</div>
                  </div>
                </div>
                <div className='body-root-in-my-card' style={{ overflow: 'hidden', overflowY: "scroll" }}>{item.content}</div>
                <div className={`floor-root-in-my-card ${this.state.language !== 'ar' ? 'lt-text' : 'rt-text'}`} >
                  {lang.from}<span >{item.sendNickname}</span>
                  <img src={item.sendAvatar}></img>
                </div>
              </div>
              <div className='love-num'>
                <img src='/img/activity/valentineDay/icon_heartx.png'></img>
                <span>{item.score}</span>
              </div>
            </div>
          ))}

        </div>
        <div style={{ height: "0.4rem", width: "7rem" }}></div>
        {showInse && <div className='text-modle' onClick={(e) => this.shopEvent(e)}>
          <div
            className="vote-modle"
            onClick={(e) => this.shopVoteEvent(e)}
          >
            <div className='vote-modle-body'>
              <div className='show-item'>
                <div className='title'>{lang.blessOne}</div>
                <div className={`select-item-invote ${selectSoreItem == 0 ? 'in-select' : ''}`} onClick={(e) => this.handelSelectSoreItem(0)}>
                  <img className='show-img' src='/img/activity/valentineDay/icon_coin.png'></img>
                  <div>50 Coins</div>
                </div>
              </div>
              <div className='show-item-two'>
                <div className='title'>{lang.blessTwo}</div>
                <div className={`select-item-invote ${selectSoreItem == 1 ? 'in-select' : ''}`} onClick={(e) => this.handelSelectSoreItem(1)}>
                  <img className='show-img' src='/img/activity/valentineDay/icon_coin.png'></img>
                  <div>100 Coins</div>
                </div>
              </div>
              <div className='show-item'>
                <div className='title'>{lang.blessThree}</div>
                <div className={`select-item-invote ${selectSoreItem == 2 ? 'in-select' : ''}`} onClick={(e) => this.handelSelectSoreItem(2)}>
                  <img className='show-img' src='/img/activity/valentineDay/icon_ruby_big.png'></img>
                  <div>100 Rubies</div>
                </div>
              </div>
            </div>
            <div className='send-btn' onClick={() => this.handleBlesscp(this.closeViewRoot)} >
              {lang.confirm}
            </div>
            <div className='cancel-btn' onClick={() => this.closeViewRoot()}>{lang.cancel}</div>
          </div>
        </div>}
        {showSend && <div className='send-modle-root' onClick={(e) => this.shopEvent(e)}>
          {hadCp && <div
            className="send-modle"
            onClick={(e) => this.shopVoteEvent(e)}
          >
            <div className='select-user'>
              {cpList.length > 0 && cpList.map((item, index) => (<div className={`in-select ${index == selectCardIndex ? 'show-root-item' : ''}`} key={index} onClick={() => this.handleSelectItem(item, index)}>
                <div className='img-root'>
                  <img src={item.avatarurl} className='user-url'></img>
                  {index == selectCardIndex && <img className='flx-in' src='/img/activity/valentineDay/controls_checkbox_selected.png'></img>}
                </div>
                <div className='name-in-user'>{item.nickname}</div>
                <div className='user-id'>ID: {item.duid}</div>
              </div>))}
            </div>
            <div className='send-modle-my-card-item' >
              <img className='my-card-item-img' src='/img/activity/valentineDay/img_lovecards_pink_new.png' style={{ transform: `${language == 'ar' ? 'scaleX(-1)' : ''}` }}></img>
              <div className='text-root'>
                <div className='top-root-in-my-card'>
                  <div className='left'>
                    {lang.to}<span >{toUp.nickname}</span>
                    <img className='rg-img' src={toUp.avatarurl}></img>
                  </div>
                </div>
                <textarea id='clearName' className='body-root-in-my-card' rows="3" cols="100" maxLength={100} onChange={(e) => this.getUserSendInputValue(e)} placeholder={lang.saysomethingtoyourlover}></textarea>
                <div className={`floor-root-in-my-card ${this.state.language !== 'ar' ? 'lt-text' : 'rt-text'}`} >
                  {lang.from}<span >{myNickname}</span>
                  <img src={myAvatarurl}></img>
                </div>
              </div>
              <div className='love-num'>
                <img src='/img/activity/valentineDay/icon_heartx.png'></img>
              </div>
            </div>
            <div className='send-btn' onClick={() => this.unLockcp(this.closeViewRoot)}>
              <span>{lang.payText}</span> <img src='/img/activity/valentineDay/icon_ruby.png' className='send-btn-img'></img><span>{lang.sendNum}</span>
            </div>
            <div className='cancel-btn' onClick={() => this.closeViewRoot()}>{lang.cancel}</div>
          </div>}
          {!hadCp && (<div
            className="nocp-modle"
          >
            <div className='nocp-modle-title'>{lang.donnothadCp}</div>
            <div className='text-conter-innocp'>{lang.nocpTip}</div>
            <div className='cle' onClick={() => close()}>{lang.okText}</div>
            <div style={{ height: '0.24rem' }}></div>
          </div>)}
        </div>}
        <Message ref="msg" desc={this.state.desc} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/valentineDay/thumbsUp/index.js